import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

import serviceManagementService from '../../../services/serviceManagementService';

const CountryServiceMatrix = ({ matrixData, onRefresh, language }) => {
  const [updating, setUpdating] = useState(false);

  if (!matrixData) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  const handleToggleAvailability = async (serviceId, countryId, currentStatus) => {
    try {
      setUpdating(true);
      await serviceManagementService?.bulkUpdateServiceAvailability(serviceId, [{
        countryId,
        isAvailable: !currentStatus,
        complianceStatus: 'compliant'
      }]);
      onRefresh();
    } catch (error) {
      console.error('Error toggling availability:', error);
      alert('Erreur lors de la mise à jour');
    } finally {
      setUpdating(false);
    }
  };

  console.log('Matrix Data:', matrixData);
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-foreground">
            Matrice de Disponibilité Globale
          </h3>
          <p className="text-sm text-muted-foreground">
            {matrixData?.services?.length} services × {matrixData?.countries?.length} pays
          </p>
        </div>
      </div>

      <div className="overflow-x-auto border border-border rounded-lg">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="sticky left-0 z-10 bg-muted/50 px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider border-r border-border">
                Service
              </th>
              {matrixData?.countries?.map((country) => (
                <th
                  key={country?.id}
                  className="px-4 py-3 text-center text-xs font-medium text-muted-foreground uppercase tracking-wider"
                  title={country?.country_name}
                >
                  {country?.country_code}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {matrixData?.matrix?.map((row) => (
              <tr key={row?.serviceId} className="hover:bg-muted/30 transition-colors">
                <td className="sticky left-0 z-10 bg-card px-4 py-3 border-r border-border">
                  <div>
                    <p className="font-medium text-foreground text-sm">{row?.serviceName}</p>
                    <p className="text-xs text-muted-foreground">{row?.serviceCode}</p>
                  </div>
                </td>
                {row?.countries?.map((country) => (
                  <td key={country?.countryId} className="px-4 py-3 text-center">
                    <button
                      onClick={() => handleToggleAvailability(row?.serviceId, country?.countryId, country?.isAvailable)}
                      disabled={updating}
                      className="inline-flex items-center justify-center w-8 h-8 rounded-lg transition-colors disabled:opacity-50"
                      title={country?.isAvailable ? 'Disponible' : 'Non disponible'}
                    >
                      {country?.isAvailable ? (
                        <Icon name="CheckCircle" size={20} className="text-green-500" />
                      ) : (
                        <Icon name="XCircle" size={20} className="text-gray-400" />
                      )}
                    </button>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex items-center gap-4 text-sm">
        <div className="flex items-center gap-2">
          <Icon name="CheckCircle" size={16} className="text-green-500" />
          <span className="text-muted-foreground">Disponible</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="XCircle" size={16} className="text-gray-400" />
          <span className="text-muted-foreground">Non disponible</span>
        </div>
      </div>
    </div>
  );
};

export default CountryServiceMatrix;